/**
 * フォームのエラー表示。
 *
 * `role="alert"` ＝スクリーンリーダーに読み上げさせる（ログイン失敗が視覚だけだと気づけない）。
 */
export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p
      role="alert"
      style={{
        margin: "0 0 var(--kz-space-4)",
        padding: "10px 12px",
        borderRadius: "var(--kz-radius-sm)",
        background: "var(--kz-status-danger-weak)",
        color: "var(--kz-status-danger)",
        fontSize: "var(--kz-font-size-sm)",
      }}
    >
      {message}
    </p>
  );
}
